<template>
	<div>
		<header class="page-title">
			<h2>{{data.name}}</h2>
		</header>
		<header class="section-title">
			<h3 class="mt-0 mb-0">General Settings</h3>
			<div class="ml-auto">
				<a @click="saveBase" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="flex box start">
			<div class="form-group four-lg mb-0">
				<label for="page-name">Page Name</label>
				<input id="page-name" type="text" v-model="data.name">
			</div>
			<div class="form-group three-lg">
				<label for="page-slug">Page Slug</label>
				<input disabled id="page-slug" type="text" v-model="data.slug">
			</div>
			<div class="form-group two-lg">
				<label for="url_slug">Url Slug</label>
				<input id="url_slug" type="text" v-model="data.url_slug">
			</div>
			<div class="form-group two-lg">
				<label for="date">Display Date</label>
				<input id="date" type="date" v-model="data.display_date">
			</div>
			<div class="form-group twelve-lg">
				<label for="page-description">Page Description</label>
				<textarea id="page-description" type="text" v-model="data.description"></textarea>
			</div>
		</div>
		<hr>
		<header class="section-title mt-2">
			<h3 class="mt-0 mb-0">Input Fields</h3>
			<div class="ml-auto">
				<a @click="showFieldModal(-1)" class="btn btn-md btn-success"><i class="fas fa-plus"></i> New Input Field</a>
			</div>
		</header>
		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th></th>
						<th>ID</th>
						<th>Label Text</th>
						<th>Input Field Type</th>
						<th>Actions</th>
					</tr>
				</thead>
				<draggable :disabled="dragDisabled" @end="reOrder" tag="tbody" v-model="fields">
					<tr :key="field.order" v-for="(field,index) in fields">
						<td class="text-center"><i class="fas fa-grip-lines"></i></td>
						<td>{{ field.id }}</td>
						<td>{{ field.label }}</td>
						<td>{{ field.type }}</td>
						<td class="nowrap">
							<a @click="showFieldModal(index)" class="btn btn-icon btn-primary"><i class="fas fa-pencil-alt" title="Edit"></i></a>
							<a @click="deleteField(index)" class="btn btn-icon btn-danger"><i class="fas fa-trash-alt" title="Trash"></i></a>
						</td>
					</tr>
				</draggable>
			</table>
		</div>

		<modal @close="closeModal" v-show="isNewModalVisible">
			<template slot="header">
				<h4 class="modal-title">Edit Input Field</h4>
			</template>
			<template slot="body">
				<div class="form-group">
					<label>ID</label>
					<input @keydown="isUnique(selectedField.id)" @keyup="checkIdType" type="text" v-model="selectedField.id">
					<p class="input-error" v-show="isUnique(selectedField.id)">ID must be unique!</p>
				</div>
				<div class="form-group">
					<label>Label Text</label>
					<input type="text" v-model="selectedField.label">
				</div>
				<div class="form-group">
					<label>Input Field Type</label>
					<select :disabled="typeLocked" v-model="selectedField.type">
						<option :value="type" v-for="type in fieldTypes">{{type}}</option>
					</select>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" class="btn btn-md btn-primary modal-close"><i class="fas fa-times"></i> Cancel</a>
				<a :disabled="isUnique(selectedField.id)" @click="addNewField" class="btn btn-md btn-success" v-if="selectedFieldIndex === -1"><i class="fas fa-save"></i> Save Changes</a>
				<a :disabled="isUnique(selectedField.id)" @click="checkIdAndSaveFields" class="btn btn-md btn-success" v-if="selectedFieldIndex !== -1"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from '../../Modal/DefaultModal.vue';
	import VueSelect from '../../../../../node_modules/vue-select';
	import draggable from 'vuedraggable';
	import {eventBus} from '../../../app';

	export default {
		props: {
			data: {
				type: Object
			},
		},
		components: {
			modal,
			"vue-select": VueSelect,
			draggable
		},
		data() {
			return {
				id: this.data.id,
				fields: this.data.fields,
				fieldTypes: [],
				orderedFields: this.data.fields,
				isNewModalVisible: false,
				selectedField: {},
				selectedFieldIndex: 0,
				ids: [],
				dragDisabled: false,
				originalId: '',
				typeLocked: false,
			}
		},
		created() {
			this.fields = this.toArray(this.fields);
		},
		mounted() {
			this.checkIds();
			this.getFieldTypes();
			this.getFields();
		},
		methods: {
			toArray: function (object) {
				return Object.keys(object).map(function (key) {
					return object[key];
				});
			},
			checkIds: function () {
				this.ids = [];
				let vm = this;
				Object.keys(this.fields).forEach(key => {
					let item = this.fields[key];
					vm.ids.push(item.id);
				});
			},
			isUnique: function (id) {
				if (typeof this.selectedField.id !== 'undefined' && this.selectedField.order !== -1) {
					if (this.fields[this.selectedField.order].id === id) {
						return false;
					}
				}
				return this.ids.includes(id);
			},
			checkIdType: function () {
				if (this.selectedField.id.includes('_body') || this.selectedField.id.includes('_copy')) {
					this.typeLocked = true;
					this.selectedField.type = 'editor';
				} else {
					this.typeLocked = false;
				}
			},
			getFieldTypes: function () {
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/staticpage/getfieldtypes',
				).then(function (response) {
					vm.fieldTypes = response.data.fieldTypes;
				}).catch(function (e) {
					vm.$toastr.error('Loading field types failed', 'Error');
				});
			},
			saveBase: function () {
				let vm = this;

				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/savebase',
					{
						slug: vm.data.slug,
						url_slug: vm.data.url_slug,
						name: vm.data.name,
						description: vm.data.description,
						display_date: vm.data.display_date
					},
				).then(function (response) {
					vm.$toastr.success('Content saved successfully.');
				}).catch(function (e) {
					vm.$toastr.error('Content saving failed.', 'Error');
				});
			},
			showFieldModal: function (index) {
				var savedFields = this.orderedFields.length > 0 ? this.orderedFields : this.fields;
				this.selectedFieldIndex = index;
				if (index !== -1) {
					this.selectedField = savedFields[index];
					this.originalId = this.copyWithoutReact(this.selectedField.id);

				} else {
					this.selectedField = {
						order: -1,
						id: 'editor-' + Math.ceil(Math.random() * 10),
						type: 'input',
						label: 'editor label here',
					};
				}
				this.checkIdType();
				this.isNewModalVisible = true;
			},
			closeModal: function () {
				this.isNewModalVisible = false;
			},
			addNewField: function () {
				let vm = this;
				this.isNewModalVisible = false;

				vm.selectedField.id = vm.selectedField.id.toLowerCase().replace(' ', '').replace(/[^0-9a-z_]/gi, '');


				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/addnewfield',
					{
						field: vm.selectedField
					},
				).then(function (response) {
					vm.$toastr.success('Content saved successfully.');
					vm.getFields();
					vm.isNewModalVisible = false;
				}).catch(function (e) {
					vm.$toastr.error('Content saving failed.', 'Error');
				});
			},
			reOrder: function () {
				this.dragDisabled = true;
				let vm = this;
				this.orderedFields = [];
				this.fields.forEach(function (item, index) {
					item['order'] = index;
					vm.orderedFields.push(item)
				});
				this.saveFields();
			},
			checkIdAndSaveFields: function () {
				if (this.originalId !== '' && this.originalId !== this.selectedField.id) {
					let vm = this;
					axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/changeid',
						{
							originalId: vm.originalId,
							field: vm.selectedField
						},
					).then(function (response) {
						vm.$toastr.success('Field ID updated successfully');
						eventBus.$emit('changeid', vm.originalId, vm.selectedField.id);
						vm.saveFields();
					}).catch(function (e) {
						vm.$toastr.error('Fields ID updating failed.', 'Error');
						vm.errors.record(e.response.data);
					});
				} else {
					this.saveFields();
				}
			},
			saveFields: function () {
				let vm = this;

				var savedFields = vm.orderedFields.length > 0 ? vm.orderedFields : vm.fields;

				this.isNewModalVisible = false;
				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/savefields',
					{
						fields: savedFields
					},
				).then(function (response) {
					vm.$toastr.success('Fields saved successfully');
					vm.getFields();
					vm.isNewModalVisible = false;
					vm.dragDisabled = false;
				}).catch(function (e) {
					vm.$toastr.error('Fields saving failed.', 'Error');
					vm.errors.record(e.response.data);
				});
			},
			getFields: function () {
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/getfields',
				).then(function (response) {
					vm.$toastr.success('Fields refreshed successfully');
					vm.fields = vm.toArray(response.data.fields);
					vm.checkIds();
					vm.$forceUpdate();
					vm.isNewModalVisible = false;
				}).catch(function (e) {
					vm.$toastr.error('Fields refreshing failed.', 'Error');
				});
			},
			deleteField: function (index) {
				let vm = this;
				this.reOrder();
				vm.$dialog.confirm('Are you sure you want to delete this field?', {
					loader: true
				})
					.then((dialog) => {
						dialog.close();
						Vue.delete(vm.orderedFields, index);
						Vue.delete(vm.fields, index);
						vm.saveFields();
					});
			},
			copyWithoutReact: function (data) {
				return JSON.parse(JSON.stringify(data));
			}
		}
	}
</script>

